var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title is-4" }, [_vm._v("Filtros de búsqueda")]),
    _vm._v(" "),
    _c("section", { staticClass: "is-flex is-flex-wrap-wrap" }, [
      _c(
        "article",
        { staticClass: "field mr-3 active-article" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("\n        Usuarios\n      "),
          ]),
          _vm._v(" "),
          _c(
            "b-dropdown",
            {
              attrs: { "aria-role": "list" },
              scopedSlots: _vm._u([
                {
                  key: "trigger",
                  fn: function () {
                    return [
                      _c("b-button", {
                        attrs: {
                          label: _vm.userActiveness.find(
                            (ua) => ua.id === _vm.queryActive
                          ).descripcion,
                          type: "is-light",
                          "icon-right": "caret-down",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.queryActive,
                callback: function ($$v) {
                  _vm.queryActive = $$v
                },
                expression: "queryActive",
              },
            },
            [
              _vm._v(" "),
              _vm._l(_vm.userActiveness, function (ua, i) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: `ua${i}`,
                    attrs: { value: ua.id, "aria-role": "listitem" },
                  },
                  [_c("span", [_vm._v(_vm._s(ua.descripcion))])]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "field mr-3 name-article" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("\n        Nombre\n      "),
          ]),
          _vm._v(" "),
          _c(
            "b-field",
            [
              _c("b-input", {
                attrs: { placeholder: "Nombre o apellido", maxlength: "35" },
                model: {
                  value: _vm.queryNameFilter,
                  callback: function ($$v) {
                    _vm.queryNameFilter = $$v
                  },
                  expression: "queryNameFilter",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "field mr-3 role-article" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("\n        Roles\n      "),
          ]),
          _vm._v(" "),
          _c(
            "b-dropdown",
            {
              attrs: {
                expanded: "",
                scrollable: _vm.isScrollable,
                "max-height": _vm.maxHeight,
                "aria-role": "list",
              },
              scopedSlots: _vm._u([
                {
                  key: "trigger",
                  fn: function () {
                    return [
                      _c("b-button", {
                        staticClass: "is-justify-content-space-between",
                        attrs: {
                          expanded: "",
                          label: _vm.queryRoleFilter
                            ? _vm.queryRoleFilter.descripcion
                            : "Todos los roles",
                          type: "is-light",
                          "icon-right": "caret-down",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.queryRoleFilter,
                callback: function ($$v) {
                  _vm.queryRoleFilter = $$v
                },
                expression: "queryRoleFilter",
              },
            },
            [
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                { attrs: { value: null, "aria-role": "listitem" } },
                [_c("span", [_vm._v("Todos los roles")])]
              ),
              _vm._v(" "),
              _vm._l(_vm.roles, function (queryRoleFilter, i) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: `rol${i}`,
                    attrs: { value: queryRoleFilter, "aria-role": "listitem" },
                  },
                  [_c("span", [_vm._v(_vm._s(queryRoleFilter.descripcion))])]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "field mr-3 mb-3 area-article" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("\n        Áreas\n      "),
          ]),
          _vm._v(" "),
          _c(
            "b-dropdown",
            {
              attrs: {
                expanded: "",
                scrollable: _vm.isScrollable,
                "max-height": _vm.maxHeight,
                "aria-role": "list",
              },
              scopedSlots: _vm._u([
                {
                  key: "trigger",
                  fn: function () {
                    return [
                      _c("b-button", {
                        staticClass: "is-justify-content-space-between",
                        attrs: {
                          expanded: "",
                          label: _vm.queryAreaFilter
                            ? _vm.queryAreaFilter.nombre
                            : "Todas las áreas",
                          type: "is-light",
                          "icon-right": "caret-down",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.queryAreaFilter,
                callback: function ($$v) {
                  _vm.queryAreaFilter = $$v
                },
                expression: "queryAreaFilter",
              },
            },
            [
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                { attrs: { value: null, "aria-role": "listitem" } },
                [_c("span", [_vm._v("Todas las áreas")])]
              ),
              _vm._v(" "),
              _vm._l(_vm.areas, function (queryAreaFilter, i) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: `area${i}`,
                    attrs: { value: queryAreaFilter, "aria-role": "listitem" },
                  },
                  [_c("span", [_vm._v(_vm._s(queryAreaFilter.nombre))])]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }